'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  gap: ${({ $small }) => ($small ? 12 : 24)}px;

  @media (max-width: ${breakpoints.mobile}) {
    justify-content: space-around;

    width: 100%;
    margin: 0 20px;
    transform: scale(0.9);
  }

  @media (max-width: ${breakpoints.smallMobile}) {
    justify-content: space-around;

    width: 100%;
    margin: 0 10px;
    transform: scale(0.8);
  }
`;

export const IconWrap = styled.div`
  transition: 0.1s all ease-in-out;

  color: ${({ $dark, $color }) => ($color ? colors[$color] : $dark ? colors.dark : colors.silver)};

  &:hover {
    cursor: pointer;
    color: ${({ $dark }) => ($dark ? colors.silver : colors.light)};
  }
`;
